<template>
    <div class="side_buttons" v-bind:class="{ active: isActive }" v-on:click="openAction">
        <a class="more_btn"><i class="fa-solid fa-angle-right"></i></a>

         <template v-for="btn in moreBtn">
                <button 
                 type="button"
                 :action="btn.id"
                 class="btn btn-secondary btn-sm"
                 @click="submit(record,`${btn.action}`,`${btn.path}`)"
                >{{btn.label}}</button>
         </template>
      
    </div>
    
</template>
<script>
export default {
    name:'moreButton',
    
    data(){
        return{
             isActive:false,
             moreBtn:[],
             record:"",
        }
    },
    methods: {
        submit(record,action,path){
            const self = this;
            if(action=='edit'){
                
                 self.$router.push('/modules/'+path+'/edit/'+record);
            }
            if(action=='delete'){
               
               const deleteRecord = {'delete_id':record};
               
               axios.post('api/modules/'+path+'/remove', deleteRecord).then(function () {
                   self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data deleted successfully').toString(),
                    type: 'success'
                });
                    self.$router.push(`/modules/${path}`);              
               });
            }
            if(action=='duplicate'){
                 self.$router.push('/modules/'+path+'/edit/'+record+'?is_duplicate='+true);
            }
            
        },
        openAction() {
            this.isActive = !this.isActive;
        },
        loadGenericBtn(btnlist){
            const self = this;
            self.moreBtn = btnlist;
            self.record = self.$route.params.id;
           
        }
    }
}
</script>